import * as React from "react";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import { Controller } from "react-hook-form";
import useResponsive from "../../../hooks/useResponsive";
import MandatoryField from "../../../utils/MandatoryField";

interface FormField {
  formLabel: string;
  name: string;
  control: any;  
  defaultValue: string;
  radioButtonArr: RadioButtonOption[];
}

interface RadioButtonOption {
  label: string;
  value: string;
  default: boolean;
}

export const RadioButtonsGroup: React.FC<FormField> = ({
  formLabel,
  name,  
  control,  
  defaultValue,  
  radioButtonArr,
}) => {
  const isMobile = useResponsive();
 
  return (
    <FormControl>
      <FormLabel
        sx={{
          fontWeight: 500,
          color: "black",
          fontSize: "14px",
          fontFamily: '"Plus Jakarta Sans", sans-serif',
        }}
        id="radio-button-group"
      >
        {formLabel}
        <MandatoryField />
      </FormLabel>
      <Controller
        name={name} // Set the name for the radio group
        control={control} // Set the react-hook-form control prop
        defaultValue={defaultValue} // Set the default value
        render={({ field }) => (
          <RadioGroup
            sx={{
              flexDirection: isMobile ? "column" : "row",
              paddingLeft: "2px"
            }}
            aria-labelledby="radio-button-group"
            value={field.value}
            onChange={(e) => field.onChange(e.target.value)}
          >
            {radioButtonArr?.map((data, index) => (
              <>
                      <FormControlLabel
                  key={index}
                  value={data.value}
                  control={<Radio />}
                  label={data.label}
                  sx={{
                    '& .MuiFormControlLabel-label': {
                      fontFamily: "Plus Jakarta Sans,sans-serif",
                    },
                  }}
                />
              </>
            ))}
          </RadioGroup>
        )}
      />
    </FormControl>
  );
}

export default RadioButtonsGroup 
